module.exports = __webpack_public_path__ + "img/guide_2_2.11d7c374.svg";